import * as types from '../types.js';

export default {

	html: `
		<style>
			#customer_route #company_id	{ width: 10rem; }
			#customer_route #id			{ width: 5rem; text-align: right; }
			#customer_route #code		{ width: 8rem; }
			#customer_route #name		{ width: 20rem; }
			#customer_route #description	{ width: 28rem; }
			#customer_route .crc-section { width: 100%; margin-top: 1rem; }
			#customer_route .crc-section table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
			#customer_route .crc-section th,
			#customer_route .crc-section td { padding: 0.25rem 0.4rem; border: 1px solid #ddd; }
			#customer_route .crc-section thead th { background: #e5e7eb; }
			#customer_route .crc-toolbar { display: flex; flex-wrap: wrap; gap: 0.4rem; margin-bottom: 0.5rem; }
			#customer_route .crc-disabled-hint { color: #b45309; font-size: 0.82rem; }
		</style>
		<form id="customer_route" class="form" autocomplete="off">
			<datalist id="companies"></datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador interno">Código interno
					<input id="id" type="text" disabled>
				</label>
				<label title="Código da rota">Código<sup>*</sup>
					<input id="code" type="text" required maxlength="32">
				</label>
				<label title="Nome da rota">Nome<sup>*</sup>
					<input id="name" type="text" required maxlength="120">
				</label>
				<label title="Descrição opcional">Descrição
					<input id="description" type="text" maxlength="500">
				</label>
				<label title="Rota inativa não aparece para novo vínculo em clientes">Inativo
					<input id="is_disabled" type="checkbox">
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_customer_route_disable" title="Inativar rota">Inativar</button>
					<button type="button" class="button bn_customer_route_enable" title="Ativar rota">Ativar</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
			<fieldset class="crc-section" id="crc_customers_section" style="display:none">
				<legend>Clientes da rota</legend>
				<p class="crc-disabled-hint" id="crc_inactive_hint" style="display:none">
					Rota inativa: visualização e exportação permitidas; adição de clientes bloqueada.
				</p>
				<div class="crc-toolbar">
					<button type="button" class="button" id="crc_btn_add">Adicionar clientes</button>
					<button type="button" class="button" id="crc_btn_export_csv">Exportar clientes CSV</button>
					<button type="button" class="button" id="crc_btn_export_xlsx">Exportar clientes XLSX</button>
				</div>
				<table>
					<thead>
						<tr>
							<th>Código/CNPJ</th>
							<th>Nick</th>
							<th>Nome</th>
							<th>Cidade</th>
							<th>Status</th>
							<th></th>
						</tr>
					</thead>
					<tbody id="crc_customers_tbody"></tbody>
				</table>
			</fieldset>
		</form>
	`,

	form: {
		selector: '#customer_route',
		init(formset)
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			const root = document.querySelector('#customer_route');
			root?.querySelector('.bn_customer_route_disable')?.addEventListener('click', () => {
				const cb = root.querySelector('#is_disabled');
				if (cb) { cb.checked = true; cb.dispatchEvent(new Event('change', { bubbles: true })); }
			});
			root?.querySelector('.bn_customer_route_enable')?.addEventListener('click', () => {
				const cb = root.querySelector('#is_disabled');
				if (cb) { cb.checked = false; cb.dispatchEvent(new Event('change', { bubbles: true })); }
			});
			Object.getPrototypeOf(this).init.call(this);
		},
		afterEditSetValues(fs)
		{
			if (typeof window.__crcRouteCustomersInit === 'function')
				window.__crcRouteCustomersInit(fs);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#code' }, types: [types.caps()] },
		{ properties: { selector: '#name' }, types: [] },
		{ properties: { selector: '#description' }, types: [] },
		{ properties: { selector: '#is_disabled' }, types: [types.checkbox()] },
	]
};
